"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultIncludesParams = void 0;
const defaultIncludes = {
    saas_bookings: [
        'customer',
        'booking_items.item.photos',
        'booking_items.item',
        'booking_items',
        'booking_services',
    ],
    saas_customers: ['customer.tax_profiles'],
    saas_inquiries: [
        'inquiry_items',
        'inquiry_items.item.photos',
        'inquiry_items.item',
        'customer',
    ],
    saas_items: ['photos'],
    stores_store: ['addresses'],
    links_permalink: [
        'owner',
        'customer',
        'booking_items',
        'booking_items.item',
        'booking_items.item.photos',
        'booking_services',
        'payments',
    ],
    market_search: ['photos', 'owner_address', 'owner'],
    stores_items: ['photos'],
    stores_item_detail: ['photos', 'owner_address', 'owner'],
    market_item_detail: ['photos', 'owner_address', 'owner'],
    market_user: ['addresses'],
};
function getDefaultIncludesParams(includes) {
    return defaultIncludes[includes];
}
exports.getDefaultIncludesParams = getDefaultIncludesParams;
//# sourceMappingURL=getIncludesParams.js.map